import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import axios from "axios";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import store from "./Store";
import { LoadingBarContainer } from "react-top-loading-bar";

// Setting the Axios base URL from environment variable
// axios.defaults.baseURL = "http://localhost:3000";
// axios.defaults.baseURL = "https://api.lokmanya.ac.in";
// axios.defaults.baseURL = "https://ec9b-2401-4900-1f3f-d7b1-50a7-c0be-707f-3d94.ngrok-free.app";
axios.defaults.headers.common["ngrok-skip-browser-warning"] = true;
// axios.interceptors.request.use(
//   (config) => {
//     config.headers["Authorization"] = `Bearer ${localStorage.getItem(
//       "access_token"
//     )}`;
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <LoadingBarContainer>
    <Provider store={store}>
      <App />
      <Toaster position="top-center" />
    </Provider>
  </LoadingBarContainer>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
